export default "__VITE_ASSET__B4brDD0V__"